(function () {
  // Re-trigger CSS animation utility
  function pop(el) {
    if (!el) return;
    el.classList.remove('qty-pop');
    // force reflow so animation can re-run
    void el.offsetWidth;
    el.classList.add('qty-pop');
  }

  // Delegate clicks on +/- buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;
    const input = btn.closest('.quantity')?.querySelector('.quantity__input');
    pop(input);
  });

  // Also catch manual typing
  document.addEventListener('input', function (e) {
    if (e.target.matches('.quantity__input')) {
      pop(e.target);
    }
  });
})();